<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>

      <div class="common-form">商业折扣</div>
      <el-form-item label="" prop="is_coupon">
        <el-button size="small" type="primary" @click="addService1" >新增商业折扣</el-button>
        <el-table :data="form.service1"  border size="mini" style="width: 100%;margin-top: 20px;">
    
      

            <el-table-column prop="num" label="介绍几个客户"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;" type="number" v-model="scope.row.num"  placeholder="请输入介绍几个客户"></el-input>
                </div>
              </template>
            </el-table-column>     


            <el-table-column prop="renewal_discount" label="续费折扣(0~10)"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;" type="number" v-model="scope.row.renewal_discount" 
                   placeholder="请输入续费折扣"></el-input>
                </div>
              </template>
            </el-table-column>   

            <el-table-column prop="name" label="排序(从小到大排序)"   width="200">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 100px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>
            </el-table-column>




  
            <el-table-column prop="name" label="操作" >
              <template v-slot="scope">
                <div style="color: blue;" @click="delService1(scope.$index)">删除</div>

              </template>
            </el-table-column>

            如果推荐的客户，使用了现金折扣不再算入商业折扣
          </el-table>
      </el-form-item>

      <div class="common-form">现金折扣</div>
      <el-form-item label="" prop="is_coupon">

        <el-table :data="form.service2"  border size="mini" style="width: 100%;margin-top: 20px;">
    


            <el-table-column prop="num" label="介绍几个客户"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  每介绍一个客户
                </div>
              </template>
            </el-table-column>     


            <el-table-column prop="cashback_commission" label="返现佣金"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;" type="number" v-model="scope.row.cashback_commission" 
                   placeholder="请输入返现佣金"></el-input>
                   <span>%</span>
                </div>
              </template>
            </el-table-column>   




            
          </el-table>
      </el-form-item>  


      <div class="common-form">其它</div>
      <el-form-item label="备注">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  






    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import DiscountApi from '@/api/discount.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
        /*富文本配置*/
        ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        status: false,
        intro:'',
        service1:[],
        service2:[{
          cashback_commission:"20"
        }]
      },
      setting: [],
      loading: false,
      isProductUpload:false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
      delService1(index){
        this.form.service1.splice(index,1)
      },
      addService1(){
        this.form.service1.push({
          "name":"",
        });
      },



    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      DiscountApi.getSetting(Params, true).then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          if(!data.data.vars.values.service1){
            self.form.service1 = [];
          }
          self.ueditor.text = self.form.intro;
          if(!data.data.vars.values.service2){
            self.form.service2 = [{
          cashback_commission:"20"
        }];
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      params.intro = this.$refs.ue.getUEContent();
      DiscountApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/discount/setting/getSetting.vue